import Alert from '@mui/material/Alert';
import type { FunctionComponent } from 'react';

type ErrorAlertProps = {
    readonly message: string;
};

export const ErrorAlert: FunctionComponent<ErrorAlertProps> = (props) => (
    <Alert severity="error" sx={{ alignItems: 'center', width: '100%' }}>
        {props.message}
    </Alert>
);
